// Parameterized non-keyword verbs (e.g. "Raise 3") for tooltip-only
// rules-text highlighting. UI-side; not consumed by the LLM prompt.
export interface XActionEntry {
  name: string;
  summary: string;
}

export const X_ACTIONS: readonly XActionEntry[] = [
  {
    name: "raise",
    summary:
      "Raise X — return the most expensive creature with cost X or less from your graveyard to your side of the battle.",
  },
  {
    name: "mill",
    summary:
      "Mill X — put the top X cards of the target player's deck into their graveyard.",
  },
];

const BY_NAME: Record<string, XActionEntry> = Object.fromEntries(
  X_ACTIONS.map((a) => [a.name, a]),
);

/** Look up the canonical summary for an X-action verb (case-insensitive). */
export function xActionSummary(name: string): string | null {
  const entry = BY_NAME[name.toLowerCase()];
  return entry ? entry.summary : null;
}

/** All X-action names (lowercase). */
export const X_ACTION_NAMES: readonly string[] = X_ACTIONS.map((a) => a.name);
